import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import TextField from "./TextField";

type PasswordFieldProps = {
  id: string;
  full?: boolean;
  className?: string;
  [key: string]: any;
};

const PasswordField: React.FC<PasswordFieldProps> = ({
  className,
  full,
  ...props
}): React.ReactElement => {
  const [visible, setVisible] = useState(false);

  return (
    <div className={`relative ${full ? "w-full" : "w-full md:w-8/12"}`}>
      <TextField
        {...props}
        full
        type={visible ? "text" : "password"}
        className={`pr-11 ${className ? className : ""}`}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setVisible((v) => !v)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 focus:outline-none"
        aria-label={visible ? "Hide password" : "Show password"}
      >
        {visible ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
};

export default PasswordField;
